import React from "react";

//Momentjs
import moment from "moment";
import "moment/locale/pt-br";

import CustomerTableItem from "./CustomerTableItem";

import {
  CTable,
  CTableRow,
  CFormCheck,
  CTableHead,
  CTableBody,
  CTableHeaderCell,
  CTableDataCell
} from "@coreui/react";

import useLocalStorage from "use-local-storage";

export default function CustomerTable(props) {
  const [theme] = useLocalStorage("theme");

  return (
    <CTable hover color={theme}>
      <CTableHead >
        <CTableRow>
          {props.checkbox && <CTableHeaderCell scope="col">
            <CFormCheck onChange={e => props.onChangeAll(e)} />
          </CTableHeaderCell>}
          <CTableHeaderCell scope="col">Foto</CTableHeaderCell>
          <CTableHeaderCell scope="col">Nome completo</CTableHeaderCell>
          <CTableHeaderCell scope="col">Ultimo login Usadão</CTableHeaderCell>
          <CTableHeaderCell scope="col">Aprovação</CTableHeaderCell>
          <CTableHeaderCell scope="col">Status</CTableHeaderCell>
          <CTableHeaderCell scope="col"></CTableHeaderCell>
          <CTableHeaderCell scope="col"></CTableHeaderCell>
        </CTableRow>
      </CTableHead>
      <CTableBody>
        {props.customers.length === 0 ? (
          <CTableRow>
            <CTableDataCell colSpan={props.checkbox ? 8 : 7} className="text-center">
              Nenhum resultado encontrado
            </CTableDataCell>
          </CTableRow>
        ) : (
          props.customers.map((customer, index) => {
            return (
              <CustomerTableItem
                setButtonPopupSocialMediaFilter={props.setButtonPopupSocialMediaFilter}
                pegaSocialMedia={props.pegaSocialMedia}
                setSelectedCustomer={props.setSelectedCustomer}
                transferCustomer={props.transferCustomer}
                checkbox={props.checkbox}
                admins={props.admins}
                onChangeCheck={props.onChangeCheck}
                key={index}
                customer={customer}
                index={index}
                fetchCustomerById={props.fetchCustomerById}
                selectedCustomer={props.selectedCustomer}
                setButtonJoinClients={props.setButtonJoinClients}
                mutations={props.mutations}
                setCustomerId={props.setCustomerId}
                setOpenChat={props.setOpenChat}
                setTriggers={props.setTriggers}
              />
            );
          })
        )}
      </CTableBody>
    </CTable>
  );
}

CustomerTable.defaultProps = {
  checkbox: true
}
